<template>
  <v-app id="inspire">
    <v-container class="bckcolor" fluid>
        <v-layout row wrap>
                  <v-flex xs12 sm12 md4></v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-container>
                      <v-card class="login-container elevation-10">
                      <!-- <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear> -->
                    <v-form class="login-form">
                     <v-layout row wrap>
                       <v-flex xs12 sm12 md12 style=" text-align: center;padding-bottom: 25px;">
                         <div class="" style="text-align: center;">
                           <img style="height: 70px;" src="../../assets/logo.png">
                         </div>
                       </v-flex>
                       <v-flex xs12 sm12 md12>
                          <v-text-field
                          v-model="UserName"
                          append-icon="person"
                          name="login"
                          label="Username or Email ID"
                          type="text"
                          ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12>
                         <v-text-field
                           v-model="Password"
                           :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                           :type="passwordShow ? 'text' : 'password'"
                           @click:append="passwordShow = !passwordShow"
                           name="password"
                           label="Password"
                         ></v-text-field>
                       </v-flex>
                       <v-flex xs12 sm12 md12>
                          <v-btn
                          style="background-image: linear-gradient(-150deg, #F78163, #F78163); margin-top: 50px; margin-bottom: 50px;"
                            
                            large
                            block
                            depressed
                            color="primary"
                            :loading="loginBtn"
                            class="white--text"
                            @click="login()"
                          >
                            LOG IN
                          </v-btn>
                       </v-flex>
                       <v-flex xs12 style="text-align:center">
                         <span class="blue--text cursr txt_dec" @click="register()">Your are new here! Create now your account</span>
                       </v-flex>
                       
                     </v-layout>
                 </v-form>
                      </v-card>
                    </v-container>
                  </v-flex>
                  <v-flex xs12 sm12 md4></v-flex>
              </v-layout>
      </v-container>

    <!-- <v-footer class="black--text pa-4" style="background-color:white">
      <v-spacer></v-spacer>
      <div class="black--text">
        &copy; {{ new Date().getFullYear() }} Developed with 💖 by
        <a
          href="http://infosyst.in/"
        >Infosyst</a>
       
      </div>&nbsp;&nbsp;&nbsp;&nbsp;
    </v-footer> -->
  </v-app>
</template>

<script>
//import config from "./../../config.json";
export default {
  data: () => ({
    loading: false,
    menu: false,
    dialog: false,
    drawer: null,
    UserName: null,
    Password: null,
    passwordShow: false,
    loginBtn: false
  }),
  props: {
    source: String
  },

  methods: {
    register() {
      this.$router.push("/register");
    },
    emobile() {
      this.$router.push("/emobile");
    },

    login() {
      this.loginBtn = true;
      let UserName = this.UserName;
      let Password = this.Password;
      this.$store
        .dispatch("login", { UserName, Password })
        .then(() => {
          this.$router.push("/_");
          this.loginBtn = false;
        }).catch(err => {
            this.$toaster.error('Wrong username or password');
            this.loginBtn = false;
          });;
    }
  }

};
</script>

<style lang="css" scoped>
.login-container {
  border-radius: 10px !important;
  border: 1px solid !important;
  border-color: #f78163 !important;
}
.login-form {
  padding: 40px;
  height: auto;
}
.login-form img {
  max-width: 100%;
  max-height: 100%;}
.bckcolor {
  /* background-image: linear-gradient(-90deg, #b41d56, #280071); */
  background-image: linear-gradient(-150deg, #FAF8ED, #FAF8ED);
  background-size: cover;
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    text-decoration: underline !important;
}
/* .centeredd {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
} */
/* .loginPage {
  background-image: url('../../assets/slider_2.jpg');
  background-size:cover
} */
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
  .login-form img {
  height: 50px;
  max-width: 100%;
  max-height: 100%;
}

}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }

}
/* .pos {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 999;
} */
</style>
